module.exports = __webpack_public_path__ + "img/xiaoqing.503b0a17.png";